import { persistSettings, type PersistedSettings } from "./settings";

// localStorageの既存値とマージしてbpslog設定を永続化する（読み取り失敗時はnextのみ保存）。
export const persistSettingsMerged = (args: {
  storageKey: string;
  next: PersistedSettings;
  transformMerged?: (
    merged: PersistedSettings,
    prev: any,
    next: PersistedSettings,
  ) => PersistedSettings;
}) => {
  const { storageKey, next, transformMerged } = args;

  try {
    const raw = window.localStorage.getItem(storageKey);
    const prev = raw ? (JSON.parse(raw) as any) : {};
    const merged: PersistedSettings = { ...prev, ...next };
    const final = transformMerged
      ? transformMerged(merged, prev, next)
      : merged;
    persistSettings(final, storageKey);
  } catch (e) {
    persistSettings(next, storageKey);
  }
};
